import React, { Fragment } from "react";

const RemoveApplication = ({
  user: { channelid, avatar, firstname, lastname, jobtitle, location },
  clearJobs,
  jobId,
  jobChannelId,
  deleteUserApplication,
  setRemoveApp,
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <form
          onSubmit={() => {
            deleteUserApplication(jobChannelId, jobId);
            setRemoveApp(false);
          }}
          className="request-box-light"
        >
          <i
            className="fas fa-times fa-3x message-x-dark"
            onClick={() => {
              setRemoveApp(false);
              clearJobs();
            }}
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div className="avi-color-border green">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="drop-down-result-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="black name-font bold">
                    {firstname} {lastname}
                  </span>
                </li>
                <li className="user-online-item-dark">{jobtitle}</li>
                <li className="user-online-item-dark">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="user-request-text-light">
            <i className="fas fa-exclamation-circle fa-lg black mr-5"></i>
            Your application has been successfully submitted to this job
            posting. Would you like to remove your application?
          </div>
          <div className="flex-center">
            <button
              className="user-request-button red background-black"
              onClick={() => {
                deleteUserApplication(channelid, jobChannelId, jobId);
                setRemoveApp(false);
              }}
            >
              Withdraw Application
            </button>
            <button
              className="user-request-button background-dark-black white"
              onClick={() => {
                setRemoveApp(false);
                clearJobs();
              }}
            >
              <i className="fas fa-times fa-sm mr-5"></i>
              Close
            </button>
          </div>
        </form>
      </div>
    </Fragment>
  );
};

export default RemoveApplication;
